module.exports = __webpack_public_path__ + "img/buckets.ae44f974.jpg";